






















































































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { BillingInfoResourceModel, BillingInfoType } from '@/modules/billing-info/models/billing-info-resource'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import collect from 'collect.js'

@Component({
  components: { BaseSelect, BaseInput }
})
export default class AdminBillingInfoBaseForm extends Vue {
  @Prop() billingInfoResource !: BillingInfoResourceModel //PropSync required
  @Prop() types !: { [key in BillingInfoType]: string }

  get res() {
    return this.billingInfoResource
  }

  get isLegal() {
    return (this.res.type === BillingInfoType.LEGAL)
  }

  get typeOptions() {
    return collect(this.types).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }
}
